<div *ngIf="criticalAlert" style="background: red!important;text-align: center!important;">
    {{currentValue  | translate }}
</div>
<div *ngIf="!criticalAlert" style="background: green!important;text-align: center!important;">
    {{currentValue  | translate  }}
</div>
